import React from 'react';

const OverviewStats = ({ overview }) => {
  if (!overview) return null;

  return (
    <div className="mb-6">
      <div className="text-lg md:text-xl font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-4">
        Peptide Statistics
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5">
        {/* User Statistics Section */}
        <div className="border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl md:p-6 p-4 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
          <h3 className="text-base font-medium text-gray-700 dark:text-shoorah-darkBg mb-3">
            User Statistics
          </h3>
          <div className="grid grid-cols-2 gap-3">
            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
              <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                Total Users
              </div>
              <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {overview.total_users_with_stacks || 0}
              </div>
            </div>

            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
              <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                Active Users
              </div>
              <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {overview.active_users_last_30_days || 0}
              </div>
            </div>

            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-shoorah-ggg">
              <div className="text-gray-400 dark:text-shoorah-darkBg text-[14px] font-medium">
                Inactive Users
              </div>
              <div className="text-black dark:text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {overview.inactive_users || 0}
              </div>
            </div>

            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
              <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                Users Tracked
              </div>
              <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {overview.users_who_tracked || 0}
              </div>
            </div>
          </div>
        </div>

        {/* Stack & Peptide Statistics Section */}
        <div className="border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl md:p-6 p-4 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
          <h3 className="text-base font-medium text-gray-700 dark:text-shoorah-darkBg mb-3">
            Stack & Peptide
          </h3>
          <div className="grid grid-cols-2 gap-3">
            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
              <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                Total Stacks
              </div>
              <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {overview.total_stacks || 0}
              </div>
            </div>

            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
              <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                Active Stacks
              </div>
              <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {overview.active_stacks || 0}
              </div>
            </div>

            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-shoorah-ggg">
              <div className="text-gray-400 dark:text-shoorah-darkBg text-[14px] font-medium">
                Inactive Stacks
              </div>
              <div className="text-black dark:text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {overview.inactive_stacks || 0}
              </div>
            </div>

            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
              <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                Peptide Groups
              </div>
              <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {overview.total_peptide_groups || 0}
              </div>
            </div>
          </div>
        </div>

        {/* Tracking Statistics Section */}
        {/* <div className="border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl md:p-6 p-4 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
          <h3 className="text-base font-medium text-gray-700 dark:text-shoorah-darkBg mb-3">
            Tracking
          </h3>
          <div className="grid grid-cols-2 gap-3">
            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
              <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                Total Check-ins
              </div>
              <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {overview.total_check_ins || 0}
              </div>
            </div>

            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
              <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                Tracked Days
              </div>
              <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {overview.total_tracked_days || 0}
              </div>
            </div>

            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white col-span-2">
              <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                Avg Tracked Days Per User
              </div>
              <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {overview.avg_tracked_days_per_user || 0}
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default OverviewStats;
